import axios from "axios";
import config from "../config/config";

// POST {serverUrl}/orders  (serverUrl already ends with /api)
// Resolves { orderNumber, emailSent, totals }. Rejects with an Error whose
// `fieldErrors` holds per-field messages when the server rejects the form.
export async function placeOrder({ customerId, customer, lines }) {
  try {
    const { data } = await axios.post(`${config.serverUrl}/orders`, {
      customerId,
      customer,
      items: lines.map((l) => ({
        description: l.description,
        variationLabel: l.variationLabel || "",
        upc: l.upc || "",
        qty: l.qty,
        priceCents: l.priceCents,
        taxRate: l.taxRate,
      })),
    });
    return data;
  } catch (err) {
    const error = new Error(err.response?.data?.message || "We couldn't place your order. Please try again.");
    error.fieldErrors = err.response?.data?.errors || {};
    throw error;
  }
}
